var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "752pt",
    height: "752pt",
    viewBox: "0 0 752 752",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m375.72 470.21-109.59 109.59c-61.504 62.062-156-32.43-94.492-94.492l109.59-109.59-109.59-109.59c-61.504-61.504 32.988-156 94.492-94.492l109.59 109.59 109.59-109.59c62.062-61.504 156.55 32.988 94.492 94.492l-109.59 109.59 109.59 109.59c62.062 62.062-32.43 156.55-94.492 94.492z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross2);
export default __webpack_public_path__ + "static/media/cross2.34ddb6a353396688f73316de043ab833.svg";
export { ForwardRef as ReactComponent };